
<!--  width="610"-->
<!--  height="138.564065"-->

<svg
  class = logo-svg
  viewBox="0,0,550,138.564065"
  xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="xMinYMid meet">
  <!-- Triangle Logo -->
  <g >
    <polygon points="0,138.564065, 160,138.564065 80,0"
             fill="var(--custom-primary)" stroke="black" stroke-width="1"/>
    <polygon points="0,138.564065 128,138.564065 64, 27.7128129"
             fill="color-mix(in srgb, var(--custom-primary) 70%, white 30%)" stroke="black" stroke-width="1"/>
    <polygon points="0,138.564065 96,138.564065 48, 55.42562584"
             fill="color-mix(in srgb, var(--custom-primary) 50%, white 50%)" stroke="black" stroke-width="1"/>
  </g>

  <!-- Text -->
  <g >
    <text x="120" y="13" font-size="42" font-weight="bold" font-family="Roboto" text-anchor="start" dominant-baseline="hanging">SYDNEY ADVANCED</text>
    <line x1="140" y1="64" x2="515" y2="64"></line>
    <text x="160" y="122" font-size="60" font-weight=250 font-family="Roboto" text-anchor="start" dominant-baseline="auto">endocrinology</text>
  </g>
</svg>

